import { IEmptyState } from "app/interfaces/empty-state/empty-state.interface";
import { IMarketplaceList } from "app/interfaces/marketplace/marketplace.interface";
import { ITextLabel } from "app/interfaces/text-label/textLabel.interface";
import ImagePath from "app/utilities/imagePath";

export interface IMarketplaceTable {
    data: IMarketplaceList,
    textLabel: ITextLabel[]
}

export interface IAgreementDocument {
	urlLoanAgreement: string
}

const textLabelTopContainer: ITextLabel[] = [
    {
        title: "Sisa Pendanaan",
        value: "",
        bg: false,
        loading: true
    },
    {
        title: "Nomor Pinjaman",
        value: "",
        bg: false,
        loading: true
    },
    {
        title: "Tenor",
        value: "",
        bg: false,
        loading: true
    },
    {
        title: "Rating",
        value: "",
        bg: false,
        loading: true
    },
    {
        title: "Minimal Pendanaan",
        value: "",
        bg: false,
        loading: true
    },
];

export const marketPlaceDummyData: IMarketplaceTable = {
    data: {
        loanId: '',
        borrowerName: '',
        loanNumber: '',
        loanTypeId: 0,
        loanTypeName: '',
        loanStatusId: 0,
        loanStatusName: '',
        dueDate: 0,
        totalLoan: 0,
        minimumFunding: 0,
        outstandingFunding: 0,
        grade: '',
        gradeDescription: '',
        tenor: 0,
        tenorPeriodId: 0,
        tenorPeriodName: '',
        interestPercentage: 0,
        interestType: 0,
        interestTypeName: '',
        marketingDescTitle: '',
        marketingDescDetail: '',
        factsheetUrl: '',
        progressPercentage: 0,
		purposeLoan: '',
    },
    textLabel: textLabelTopContainer
};

export const marketplaceTableInit: IMarketplaceTable[] = [
    marketPlaceDummyData,
    marketPlaceDummyData,
    marketPlaceDummyData
];

export const marketplaceListEmptyState: IEmptyState = {
	image: ImagePath.marketplaceNoData,
	placeholder: "Waah saat ini semua pinjaman sudah terdanai",
	caption: "Mohon tunggu untuk penawaran pendanaan berikutnya ya"
};

export const marketplaceListAction = [
	{
		id: 1,
		label: 'Unduh Factsheet'
	},
];

export const MARKETPLACE_ENUM = {
	downloadFactsheet: 1,
};

export const BULK_MARKETPLACE_CONFIG = [
    {
        id: 'loanType',
        formType: 'multi-select',
        placeholder: 'Tipe Pinjaman',
        name: 'loanType',
        apiErrorMessage: '',
        options: [],
        value: '',
    },
    {
        id: 'tenor',
        formType: 'number',
        placeholder: 'Tenor',
        name: 'tenor',
        apiErrorMessage: '',
        options: [],
        value: '',
    }
];
